export enum IframeMessageType {
  REGISTRATION_COMPLETED = 'registrationCompleted',
  ONBOARDING_COMPLETED = 'onboardingCompleted',
  CLOSE_IFRAME_WINDOW = 'closeIframeWindow',
}
